
export default {
    props: {
        category: { type: Object, required: true },
    },
    computed: {
        currentCategory() {
            return this.$store.getters['restaurants/currentCategory'];
        },
        active() {
            return this.currentCategory && this.currentCategory.slug === this.category.slug;
        },
        style() {
            let style = '';
            if (this.category.cover && this.category.cover !== '') {
                style += `background:linear-gradient(90deg, rgba(0,0,0,0.0), rgba(0,0,0,0)), url("${this.category.cover}?auto=compress&cs=srgb&w=500") center center no-repeat;`;
            } else {
                // style += 'background:#000000;';
                style += `background:linear-gradient(90deg, rgba(0,0,0,0.0), rgba(0,0,0,0)), url("/img/food_placeholder.jpeg") center center no-repeat;`;
            }
            style += 'background-size:cover;';
            return style;
        }
    },
    methods: {
        setCategory() {
            const category =
                this.currentCategory && this.currentCategory.slug === this.category.slug ? null : this.category;
            this.$store.commit('restaurants/setCurrentCategory', category);
        },
    },
};
